import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  collect(data) {
    // TODO: actual work to collect data
    return new Promise((resolve, reject) => {
      if (data && data.length > 0) {
        resolve(data);
      } else {
        var error = new TypeError(
          'Excelに空白があるか、誤ったデータが保存されています。「破棄」を選択して前の画面に戻り、Excelを修正して再度取り込んでください。'
        );
        reject(error);
      }
    });
  },
  import(data) {
    return BackendAPI('post', ApiRoutes.student.import(), data);
  },
};
